/* LTCG Clarity UX 2026-10-27 (deferred, no dependencies, ~2 KB).
   1) Removes deal tags/links ([data-ltcg-end] = unix seconds) on the shopper's clock when the deal ends,
      so a cached page never shows "−25%" after 31.10 23:59:59.
   2) Quick-chips "Card set" sheet: open/close (<dialog>), search box that filters the set list (e.g. "m6a").
   Delegated listeners only, so it also works after the collection section re-renders via AJAX. */
(() => {
  if (window.__ltcgUx) return; window.__ltcgUx = 1;

  // 1 — honest end of deal tags
  const sweep = () => {
    const now = Date.now() / 1000;
    let next = Infinity;
    document.querySelectorAll('[data-ltcg-end]').forEach((el) => {
      const end = parseInt(el.dataset.ltcgEnd, 10);
      if (!end) return;
      if (now > end) el.remove(); else next = Math.min(next, end);
    });
    if (next !== Infinity && next - now < 86400) setTimeout(sweep, Math.max(1000, (next - now) * 1000 + 500));
  };
  sweep();
  // content rendered later (search dropdown, filter re-render) or a tab left open: re-check cheaply, no observers
  let last = 0;
  const soon = () => { const t = Date.now(); if (t - last > 2000) { last = t; setTimeout(sweep, 400); } };
  document.addEventListener('focusin', soon, { passive: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) sweep(); });

  // 2 — Card set sheet
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-ltcg-qc-open]');
    if (open) {
      const d = open.closest('[data-ltcg-qc]')?.querySelector('[data-ltcg-qc-sheet]');
      if (d && d.showModal) { d.showModal(); setTimeout(() => { if (matchMedia('(hover:hover)').matches) d.querySelector('[data-ltcg-qc-find]')?.focus(); }, 50); }
      return;
    }
    if (e.target.closest('[data-ltcg-qc-close]')) { e.target.closest('dialog')?.close(); return; }
    if (e.target.matches?.('dialog[data-ltcg-qc-sheet]')) e.target.close(); // backdrop tap
  });
  document.addEventListener('input', (e) => {
    const f = e.target.closest?.('[data-ltcg-qc-find]');
    if (!f) return;
    const q = f.value.trim().toLowerCase().replace(/\s+/g, ' ');
    const d = f.closest('dialog');
    let shown = 0;
    d.querySelectorAll('[data-ltcg-qc-list] a').forEach((a) => {
      const hit = !q || a.dataset.q.includes(q);
      a.parentElement.hidden = !hit; if (hit) shown++;
    });
    const none = d.querySelector('[data-ltcg-qc-none]'); if (none) none.hidden = shown > 0;
  });
})();
